import { Tooltip, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router-dom";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import withIntl from "../../utils/withIntl";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import IconButton from "@material-ui/core/IconButton";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import AuthorizationWrapper from "../AuthorizationWrapper";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    display: "block",
  },

  listContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignContent: "flex-start",
    margin: 5,
    overflowY: "scroll",
    height: 175,
    padding: 3,
    width: "100%",
  },
}));

function LinkedItems(props) {
  const classes = useStyles();

  return (
    <>
      <Typography style={{ fontWeight: 800, marginRight: 10, marginTop: 20 }}>{props.title}</Typography>
      <div style={{ display: "flex", flexFlow: "row wrap", marginBottom: 20 }}>
        {props.linkedItems.map((itemObject) => {
          return (
            <div style={{ display: "flex" }}>
              <Button
                disabled={!!props.disabledButtons}
                onClick={() => {
                  props.history.push(itemObject.link);
                }}
                classes={{ text: classes.rootButton }}
              >
                {itemObject.name}
              </Button>
              {props.onDelete && (
                <AuthorizationWrapper
                  permission={props.authorizationPrefix + ".unlink"}
                  child={
                    <Tooltip title={props.intl.formatMessage({ id: "delete" })}>
                      <IconButton onClick={() => props.onDelete(itemObject.id)}>
                        <HighlightOffIcon size={"small"} />
                      </IconButton>
                    </Tooltip>
                  }
                />
              )}
            </div>
          );
        })}
        {props.onAdd && (
          <AuthorizationWrapper
            permission={props.authorizationPrefix + ".link"}
            child={
              <Tooltip title={props.intl.formatMessage({ id: "add_new" })}>
                <Button
                  onClick={props.onAdd}
                  color={"primary"}
                  classes={{ text: classes.rootButton }}
                  startIcon={<AddCircleIcon color={"primary"} size={"small"} />}
                >
                  {props.intl.formatMessage({ id: "add" })}
                </Button>
              </Tooltip>
            }
          />
        )}
      </div>
    </>
  );
}

export default withRouter(withIntl(LinkedItems));
